import { Fragment, useState } from "react";

export default function CitiesOverview(params) {
	
	const cities = params.data;

  console.log( cities );

  const [citiesToShow, setCitiesToShow] = useState( cities );
  const [activeCity, setActiveCity] = useState( 'Alle' )

  let citiesMap = {};
  cities.forEach(
    city => {
      
      let currentCityName = city.name.split( ' ', 1 )[0];

      if ( ! citiesMap[currentCityName] ) {
        citiesMap[currentCityName] = [city];
      } else {
        citiesMap[currentCityName].push( city );
      }

    }
  );

  const applyCitiesFilter = cityName => {

    if ( ! citiesMap[cityName] ) {
      setActiveCity( 'Alle' )
      setCitiesToShow( cities );
      return;
    }

    setActiveCity( cityName );
    setCitiesToShow( citiesMap[cityName] );

  }

  return (
    <Fragment>
      <div className="m-0 staedte-overview-container">

        <div className="d-flex justify-content-between flex-column flex-lg-row">

          <div className="">

            <h1 style={{fontSize: "30px"}}>
              {window.staedteFrontendShortcodeData.i18n.ourEventCities}
            </h1>

          </div>

          <div className="d-flex mb-3 flex-row">
            <div className="mt-auto mb-auto me-3">
              <b>
                {window.staedteFrontendShortcodeData.i18n.choseYourCity}
              </b>
            </div>
            <div className="ms-auto dropdown staedte-filter-dropdown text-start">
              <button
                className="btn btn-lg dropdown-toggle staedte-filter-button"
                type="button"
                data-bs-toggle="dropdown"
                aria-expanded="false"
              >
                {activeCity}
              </button>
              <ul class="staedte-filter-dropdown dropdown-menu list-unstyled w-100 text-start ps-0 pb-0">
                <li role="button" onClick={()=>{applyCitiesFilter(window.staedteFrontendShortcodeData.i18n.all)}} className={ window.staedteFrontendShortcodeData.i18n.all === activeCity ? 'active dropdown-item' : 'dropdown-item' }>
                  {window.staedteFrontendShortcodeData.i18n.all}
                </li>
                {
                  Object.keys( citiesMap ).map(
                    cityName => {
                      return (
                        <li role="button" onClick={()=>{applyCitiesFilter(cityName)}} key={cityName} className={ cityName === activeCity ? 'active dropdown-item' : 'dropdown-item' }>
                              {cityName}
                        </li>
                      )
                    }
                  )
                }
              </ul>

            </div>
          </div>

        </div>


        <div className="d-flex flex-wrap">

          {citiesToShow.map((city) => {

            let ticketshopActive = 1 === Number( city.ticketshopActive );

            return (

              <a
                href={`/staedte?stadt=${city.cityShortcode}`}
                key={city.cityShortcode}
                className={ (city.date ? '' : 'city-disabled ') + `staedte-city-card align-items-stretch text-decoration-none`}
              >

                <div className="card h-100 border-0">

                  <img
                    className="staedte-city-img"
                    alt={city.name}
                    src={city.imgUrl}
                  />

									{
										city.date && 'MYBSC' !== window.staedteFrontendShortcodeData.event && ticketshopActive ? 
                      <span
                        className="staedte-date-text"
                      >
                        {`${city.weekDay}, ${city.date}`}
                      </span> : ''
									}

									<div
                    className="staedte-city-info-text-container"
                  >

										<p className="staedte-city-info-text-city-name">
                      <b>{city.name}</b>
                    </p>

                    {
                      (
                        1<city.endlocations && 'MYBSC' !== window.staedteFrontendShortcodeData.event ?
                          <p className={' staedte-city-info-text-endlocations'}>
                            {`(${city.endlocations} Endlocations)`/* TODO: i18n */}
                          </p> : ''
                      )
                    }


									</div>

                </div>

              </a>

            );
          })}

        </div>

      </div>

    </Fragment>
  );
}